import { useEffect, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import Log from 'forms-utils-lib/logger/Logger';
import PortalIdParser from 'PortalIdParser';
import { createNewDefaultForm } from 'FormsUI/api/NewEditorCreation';
import { getSelectedBusinessUnitId } from 'FormsUI/selectors/FormCreation';
import { REQUEST_FORM_CREATION, SUCCEED_CREATING_FORM, FAIL_CREATING_FORM } from 'FormsUI/actions/formCreation/formCreationActions';
import redirectToNewEditor from 'FormsUI/actions/formCreation/newEditor/redirectToNewEditor';

/* This component is used for the onboarding plan to skip the
 template selection step and redirect to the new editor
*/
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingScreenOnboarding = () => {
  const dispatch = useDispatch();
  const businessUnitId = useSelector(getSelectedBusinessUnitId);
  const [processStatus, setProcessStatus] = useState('loading');
  const handleBackgroundFormCreation = useCallback(async () => {
    try {
      dispatch({
        type: REQUEST_FORM_CREATION
      });
      const {
        id
      } = await createNewDefaultForm({
        businessUnitId
      });
      dispatch({
        type: SUCCEED_CREATING_FORM
      });
      setProcessStatus('success');
      redirectToNewEditor(id, 'onboardingPlan');
    } catch (err) {
      Log.error('Error creating form:', err);
      dispatch({
        type: FAIL_CREATING_FORM
      });
      setProcessStatus('error');
      window.location.replace(`/forms/${PortalIdParser.get()}/`);
    }
  }, [businessUnitId, dispatch]);
  useEffect(() => {
    void handleBackgroundFormCreation();
  }, [handleBackgroundFormCreation]);
  return /*#__PURE__*/_jsx(NavMarker, {
    name: `ONBOARDING_FORM_CREATION_${processStatus.toUpperCase()}`,
    children: /*#__PURE__*/_jsx(LoadingOverlay, {
      contextual: true
    })
  });
};
export default LoadingScreenOnboarding;